import React from "react";
import { Card } from "primereact/card";
import { Button } from 'primereact/button';
import { utitService } from '../../services/util';

const TrainingUserDetailsView = ({ clickedRowData }) => {

  const trainingStatusTemp = (rowData) => {
    if (rowData?.trainingDetailStatus === 1) {
      return <span>In Progress</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        !rowData?.is_assessment && !rowData?.is_feedback
      ) ||

      // Case 2: Non-Instructor-Led with specific criteria
      (rowData?.trainingType === 'Self-Paced' &&
        !rowData?.is_assessment && !rowData?.is_feedback
      )
    )
    ) {
      return <span>Attended</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        rowData?.is_assessment &&
        rowData?.is_feedback &&
        !rowData?.is_assesment_completed &&
        !rowData?.is_feedback_completed
      )
    )
    ) {
      return <span>Assessment Pending</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        rowData?.is_assessment &&
        rowData?.is_feedback &&
        rowData?.is_assesment_completed &&
        !rowData?.is_feedback_completed
      ) ||
      // Case 2: Non-Instructor-Led with specific criteria
      (rowData?.trainingType === 'Self-Paced' &&
        !rowData?.is_assessment &&
        rowData?.is_feedback &&
        !rowData?.is_assesment_completed &&
        !rowData?.is_feedback_completed
      )
    )
    ) {
      return <span>Feedback Pending</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        rowData?.is_assessment &&
        rowData?.is_feedback &&
        rowData?.is_assesment_completed &&
        rowData?.is_feedback_completed
      ) ||
      // Case 2: Non-Instructor-Led with specific criteria
      (rowData?.trainingType === 'Self-Paced' &&
        !rowData?.is_assessment &&
        rowData?.is_feedback &&
        !rowData?.is_assesment_completed &&
        rowData?.is_feedback_completed
      )
    )
    ) {
      return <span>Completed</span>;
    }
    // Fallback
    return <span>TODO</span>;
  };

  return (
    <>
      <hr />
      <div className="row mp-panel">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Project Name :</div>
            <div className='col'>
              {clickedRowData?.projectName ? clickedRowData?.projectName : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Target Skill :</div>
            <div className='col'>
              {clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Category Of Training :</div>
            <div className='col'>
              {clickedRowData?.categoryOfTrainings ? clickedRowData?.categoryOfTrainings?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Type :</div>
            <div className='col'>
              {clickedRowData?.trainingType ? clickedRowData?.trainingType : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Progress Status :</div>
            <div className='col'>
              {/* {clickedRowData?.trainingDetails[0] ? utitService.getUserTrainingStatus(clickedRowData?.trainingDetails[0]?.trainingDetailStatus) : '-'} */}
              {/* {clickedRowData?.trainingDetails[0]?.trainingDetailStatus === 1 ? 'In Progress' : clickedRowData?.trainingDetails[0]?.trainingDetailStatus === 2 && !clickedRowData?.trainingDetails[0]?.is_assessment && !clickedRowData?.trainingDetails[0]?.is_feedback ? 'Attended' : clickedRowData?.trainingDetails[0]?.trainingDetailStatus === 2 && clickedRowData?.trainingDetails[0]?.is_assessment && clickedRowData?.trainingDetails[0]?.is_feedback && !clickedRowData?.trainingDetails[0]?.is_assesment_completed && !clickedRowData?.trainingDetails[0]?.is_feedback_completed ? 'Assesment Pending' : clickedRowData?.trainingDetails[0]?.trainingDetailStatus === 2 && clickedRowData?.trainingDetails[0]?.is_assessment && clickedRowData?.trainingDetails[0]?.is_feedback && clickedRowData?.trainingDetails[0]?.is_assesment_completed && !clickedRowData?.trainingDetails[0]?.is_feedback_completed ? 'Feedback Pending' : clickedRowData?.trainingDetails[0]?.trainingDetailStatus === 2 && clickedRowData?.trainingDetails[0]?.is_assessment && clickedRowData?.trainingDetails[0]?.is_feedback && clickedRowData?.trainingDetails[0]?.is_assesment_completed && clickedRowData?.trainingDetails[0]?.is_feedback_completed ? 'Completed' : 'TODO'} */}
              {trainingStatusTemp(clickedRowData?.trainingDetails[0])}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Progress(In Percentage) :</div>
            <div className='col'>
              {clickedRowData?.trainingDetails[0] ? clickedRowData?.trainingDetails[0]?.percentage : 'Not Updated Yet'}
            </div>
          </div>
          <div className="col-3">
            <div className='col trf-Detail-Label'>View Certificate :</div>
            <div className='col'>
              <Button label="View" disabled />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="mp-panel col-12">
            <div className='col trf-Detail-Label'>Expected Business Outcome :</div>
            {clickedRowData?.businessoutcome?.map((item, index) => (
              <div className='col mr-2 bordered mt-1'>
                {item.title}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Progress Update :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>
                {clickedRowData?.trainingDetails[0] ? clickedRowData?.trainingDetails[0]?.progressUpdate : 'Not Updated Yet'}
              </Card>
            </div>
          </div>
          <div className="col-6">
            <div className='col trf-Detail-Label'>Training Learnings :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>
                {clickedRowData?.trainingDetails[0] ? clickedRowData?.trainingDetails[0]?.trainingLearning : 'Not Updated Yet'}
              </Card>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Learning Apply on Project :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>
                {clickedRowData?.trainingDetails[0] ? clickedRowData?.trainingDetails[0]?.learningApplyOnProject : 'Not Updated Yet'}
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TrainingUserDetailsView;
